import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_REBALANCE_TIMESTAMP } from './rebalanceBreadcrumb.query';

export function RebalanceBreadcrumb() {
  const { data } = useQuery(FETCH_REBALANCE_TIMESTAMP, {
    variables: { rebalanceId: useParams().id },
  });
  const { t } = useTranslation();
  const { localizedDateTime } = useLocalization();

  return `${t('rebalance:rebalanceOn')} ${data ? localizedDateTime(data.fetchRebalance?.rebalance.createdAt) : ''}`;
}
